export const formatPhoneNumber = (value) => {
  if (!value) return value;

  const cleaned = value.replace(/\D/g, "");

  const length = cleaned.length;

  if (length < 4) return cleaned;
  if (length < 7) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
};
